<template>
  <div class="nameAndIdentitycard-wrap">
    <div class="tip">为了保证电子签约的法律效力，您需要先进行实名认证</div>
    <div class="content">
      <div class="label">姓名</div>
      <van-field
        v-model="userFullName"
        placeholder="请输入真实姓名"
        :disabled="disabled"
      />
      <div class="label">证件号</div>
      <van-field
        v-model="userIdCardNo"
        placeholder="请输入证件号"
      />
      <div class="label">证件类型</div>
      <van-cell is-link @click="showPopup">{{ typeStr }}</van-cell>
      <!-- <div class="des">
        <van-checkbox
          v-model="checked"
          checked-color="#1676FF"
        ></van-checkbox>
        <p>
          我已阅读并同意
          <span>《隐私保护协议》</span>
        </p>
      </div> -->
    </div>
    <!-- 证件照片逻辑（已注释，方便恢复）
    <div class="id-card-wrap">
      <div class="card-head">
        <span class="card-title">证件照片</span>
        <span class="card-desc">请上传身份证人像面和国徽面</span>
      </div>
      <div class="id-uploads">
        <div
          class="id-upload-item"
          v-for="item in idCardSides"
          :key="item.key"
        >
          <van-uploader
            :after-read="(file) => afterReadIdCard(file, item.key)"
            :max-count="1"
            :max-size="5 * 1024 * 1024"
            @oversize="onOversize"
          >
            <div class="id-upload-box">
              <van-loading
                v-if="item.loading"
                type="spinner"
                color="#1676FF"
                size="24"
              />
              <img
                v-else-if="item.url"
                :src="item.url"
                class="id-preview"
              />
              <div v-else class="id-placeholder">
                <van-icon name="photograph" size="28" color="#C8D0DE" />
              </div>
            </div>
          </van-uploader>
          <div class="id-upload-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
    -->

    <div class="footer" v-if="!isPopup">
      <template v-if="canClick">
        <div class="btn" @click="twoElements">下一步</div>
      </template>
      <template v-else>
        <div class="btn btn2">下一步</div>
      </template>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-picker
        title="标题"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/api'
// import Apifiles from '@/api/files' // 证件照逻辑（已注释，方便恢复）
import { Dialog, Toast } from 'vant'

export default {
  props: ['isPopup'],
  data() {
    return {
      userFullName: '',
      userIdCardNo: '',
      checked: true,
      disabled: false,
      show: false,
      columns: ['内地'],
      typeStr: '内地',
      type: 1,
      loading: false,
      // 证件照逻辑（已注释，方便恢复）
      // frontUrl: '', // 人像面 本地预览(base64)
      // frontImgKey: '', // 人像面 fileKey
      // frontUploading: false,
      // backUrl: '', // 国徽面 本地预览
      // backImgKey: '', // 国徽面 fileKey
      // backUploading: false,
    }
  },
  computed: {
    ...mapState({
      systemInfo: state => state.system,
    }),
    canClick() {
      if (
        this.userFullName &&
        this.userIdCardNo &&
        this.checked
        // 证件照逻辑（已注释，方便恢复）
        // && this.frontImgKey &&
        // this.backImgKey
      )
        return true
      return false
    },
    /* 证件照逻辑（已注释，方便恢复）
    idCardSides() {
      return [
        {
          key: 'front',
          label: '人像面',
          url: this.frontUrl,
          loading: this.frontUploading,
        },
        {
          key: 'back',
          label: '国徽面',
          url: this.backUrl,
          loading: this.backUploading,
        },
      ]
    },
    */
  },
  async created() {
    const { url } = this.$route.query
    await this.$store.dispatch('fetchUserInfo')
    this.userId = this.$store.state.user.userInfo.userId
    console.log("🚀 ~ this.userId:", this.$store.state.user.userInfo)
    if (!this.userId) {
      this.$router.push({
        path: '/My',
      })
    }
    this.telephone = this.$store.state.user.userInfo.telephone
    this.$store.commit('setSignUrl', url)
    this.$store.commit('setCreditType', 100)
  },
  methods: {
    showPopup() {
      this.show = true
    },
    onConfirm(value, index) {
      this.typeStr = value
      this.type = index + 1
      this.show = false
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`)
    },
    onCancel() {
      this.show = false
    },
    /* 证件照逻辑（已注释，方便恢复）
    onOversize() {
      Toast('图片大小不能超过 5M')
    },
    async afterReadIdCard(file, side) {
      const imgType = `.${file.file.name
        .split('.')
        .pop()
        .toLowerCase()}`
      if (!['.jpg', '.jpeg', '.png'].includes(imgType)) {
        Toast('仅支持 jpg、png 格式')
        return
      }
      this[`${side}Uploading`] = true
      this[`${side}Url`] = file.content // 本地预览
      try {
        const { fileKey } = await Apifiles.uploadNew({
          objectBase64: file.content,
          objectFormat: imgType,
        })
        this[`${side}ImgKey`] = fileKey
      } catch (err) {
        Toast('上传失败，请重试')
        this[`${side}Url`] = ''
        console.log(err)
      } finally {
        this[`${side}Uploading`] = false
      }
    },
    */
    twoElements() {
      if (this.loading) return
      // 证件照校验逻辑（已注释，方便恢复）
      // if (!this.frontImgKey || !this.backImgKey) {
      //   Toast('请上传身份证人像面和国徽面')
      //   return
      // }
      this.loading = true
      Api.twoElements({
        userFullName: this.userFullName,
        userIdCardNo: this.userIdCardNo,
        userId: this.userId,
        systemId: this.systemInfo.systemId,
        type: this.type,
      })
        .then(res => {
          const { data, status, msg } = res
          if (status === 201) {
            Dialog.alert({
              title: '',
              message: msg,
              confirmButtonText: '重新输入',
            }).then(() => {
              this.userFullName = ''
              this.userIdCardNo = ''
            })
            return
          }
          if (status === 200) {
            sessionStorage.setItem(
              'auth_info',
              JSON.stringify({
                // 证件照逻辑（已注释，方便恢复）
                // idCardBack: this.backImgKey,
                // idCardFront: this.frontImgKey,
                idcardNo: this.userIdCardNo,
                userName: this.userFullName,
              })
            )
            this.$store.commit('setCreditMsg', {
              userFullName: this.userFullName,
              userIdCardNo: this.userIdCardNo,
              userId: this.userId,
              telephone: this.telephone,
            })
            const { redirectUrl } = this.$route.query
            this.$router.push({
              name: 'auth',
              query: {
                redirectUrl,
              },
            })
            return
          }
          Toast(msg)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
.nameAndIdentitycard-wrap {
  width: 100%;
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 90px;

  .tip {
    font-size: 14px;
    padding: 16px;
    color: rgba(22, 118, 255, 1);
  }
  .content {
    background: #fff;
    padding: 0 16px;
    .label {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 26, 52, 1);
      line-height: 22px;
      margin-bottom: 8px;
    }
    /deep/.van-cell {
      padding: 13px 0;
      height: 48px;
      margin-bottom: 24px;
    }
    .van-cell::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
    .van-cell:last-child::after {
      display: inline-block;
    }
  }
  .id-card-wrap {
    background: #fff;
    margin-top: 12px;
    padding: 0 16px;

    .card-head {
      display: flex;
      align-items: baseline;
      padding-top: 16px;

      .card-title {
        font-size: 14px;
        font-weight: 500;
        color: #111a34;
      }

      .card-desc {
        font-size: 12px;
        color: #969799;
        margin-left: 8px;
      }
    }

    .id-uploads {
      display: flex;
      justify-content: space-between;
      padding: 12px 0 16px;

      .id-upload-item {
        width: calc(50% - 6px);
        text-align: center;

        /deep/ .van-uploader,
        /deep/ .van-uploader__input-wrapper,
        /deep/ .van-uploader__wrapper {
          width: 100%;
        }

        .id-upload-box {
          width: 100%;
          height: 105px;
          background: #f7f8fa;
          border: 1px dashed #dcdee0;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          .id-preview {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .id-upload-label {
          font-size: 14px;
          color: #646566;
          margin-top: 8px;
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: env(safe-area-inset-bottom);
    left: 0;
    width: 100%;
    height: 66px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -6px 10px 0px rgba(230, 234, 237, 0.3);
    padding-top: 10px;
    .btn {
      width: 327px;
      height: 44px;
      background: rgba(22, 118, 255, 1);
      box-shadow: 0px 6px 20px 0px rgba(78, 128, 245, 0.16);
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      margin: 0 auto;
    }
    .btn2 {
      background: rgba(22, 118, 255, 0.2);
    }
  }
}
</style>
